import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <Router>
  <AuthProvider>
  <CartProvider>
    <App/>
    
    </CartProvider>
    </AuthProvider>

 </Router>,
 document.getElementById('root')
   
    
   
  
);



